import { render, staticRenderFns } from "./xmlManage.vue?vue&type=template&id=3af283ee"
import script from "./xmlManage.vue?vue&type=script&lang=js"
export * from "./xmlManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports